import pipe from 'ramda/src/pipe'
import prop from 'ramda/src/prop'
import auditEndpoint from 'root/src/client/logic/api/util/auditEndpoint'
import authenticationSelector from 'root/src/client/logic/auth/selectors/authenticationSelector'
import nextAjax from 'root/src/client/util/nextAjax'
import { getDareDropApiUrl } from 'root/src/client/v2/common/api/getDareDropApiUrl'

export default async (endpointId, payload, state, token = undefined) => {
	if (!auditEndpoint(endpointId, state)) return {}
	const accessToken = pipe(
		authenticationSelector,
		prop('accessToken'),
	)(state) || token

	const requestPayload = {
		endpointId,
		payload,
		...(accessToken ? { authentication: accessToken } : {}),
	}

	return nextAjax({
		method: 'POST',
		url: getDareDropApiUrl(),
		body: requestPayload,
	}, false)
}
